import React, { useCallback } from "react";
import {
  getCurrentUserFromLocalStorage,
  getI18nLanguageFromLocalStorage,
} from "../../helpers/localStorageHelper";
import { getAvailablePassProducts } from "../../services/passService";
import PassPromoStrip from "./PassPromoStrip";

export default function PassBanner({ enabled, productCode, offerEndDate }) {
  const handleCtaClick = useCallback(async () => {
    const lang = getI18nLanguageFromLocalStorage();

    if (!getCurrentUserFromLocalStorage()) {
      window.location.href = `/auth/login?lang=${lang}&returnUrl=${window.location.pathname}`;
      return;
    }

    const passProducts = await getAvailablePassProducts().catch(() => []);
    const passProduct = (passProducts ?? [])[0];
    if (!passProduct?.productPublicId) return;

    const query = new URLSearchParams({
      isQuickBuy: true,
      productId: passProduct.productPublicId,
      quantity: 1,
    }).toString();
    window.location.href = `/${lang}/shopping-cart?${query}`;
  }, []);

  return (
    <PassPromoStrip
      onCtaClick={handleCtaClick}
      enabled={enabled}
      productCode={productCode}
      offerEndDate={offerEndDate}
    />
  );
}
